import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import HeaderNav from './shared/javascripts/components/HeaderNav'
import FooterNav from './shared/javascripts/components/FooterNav'
import AppRoutes from './routes'
import './App.css';

const App = ({ currentUser }) => {

  return (
    <div className='App'>
      <HeaderNav currentUser={currentUser} />
      <div className="container">
        <AppRoutes currentUser={currentUser} />
      </div>
      <FooterNav />
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.reduxTokenAuth.currentUser
})

export default withRouter(connect(mapStateToProps, null)(App))


// WEBPACK FOOTER //
// ./src/App.jsx